import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { FG16A } from '../../../services/pwg208Api';

interface Tab5AuditLogsProps {
  auditLogs: FG16A[];
}

const Tab5AuditLogs: React.FC<Tab5AuditLogsProps> = React.memo(({ auditLogs }) => {
  const columns: ColumnsType<FG16A> = [
    {
      title: <span data-contract-field="fg16a_11">動作代碼</span>,
      dataIndex: 'fg16a_11',
      key: 'fg16a_11',
      width: 100,
    },
    {
      title: <span data-contract-field="fg16a_02">操作人員</span>,
      dataIndex: 'fg16a_02',
      key: 'fg16a_02',
      width: 120,
    },
    {
      title: <span data-contract-field="fg16a_03">操作日期</span>,
      dataIndex: 'fg16a_03',
      key: 'fg16a_03',
      width: 120,
    },
    {
      title: <span data-contract-field="fg16a_04">操作時間</span>,
      dataIndex: 'fg16a_04',
      key: 'fg16a_04',
      width: 100,
    },
  ];

  return (
    <div className="pwg208-tab5">
      <Table<FG16A>
        columns={columns}
        dataSource={auditLogs}
        rowKey={(r) => String(r.id)}
        pagination={false}
        size="small"
        scroll={{ y: 350 }}
        locale={{ emptyText: '無審核紀錄' }}
      />
    </div>
  );
});

Tab5AuditLogs.displayName = 'Tab5AuditLogs';

export default Tab5AuditLogs;
